export const isInternalDomain = (domain: string): boolean => {
    return domain.includes("junipercreates.com") || domain.includes("hellojuniper.com");
}
